import { render, staticRenderFns } from "./ot-claim-recommendation.vue?vue&type=template&id=9bfe12b0&scoped=true&"
import script from "./ot-claim-recommendation.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-recommendation.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-recommendation.vue?vue&type=style&index=0&id=9bfe12b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfe12b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
